export enum EventName {
    goal = "Goal",
    half = "Half",
    incident = "Incident",
    penalties = "Penalties",
    penaltyShot = "PenaltyShot",
    substitution = "Substitution",
    abandoned = "Abandoned",
    stoppage = "Stoppage",
    suspension = "Suspension",
    oneMinuteTimer = "OneMinuteTimer",
}
